// extracted by mini-css-extract-plugin
module.exports = {"reviews":"reviews_legacy_reviews__227Nu"};